import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { common } from 'src/app/app.common';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, MaxLengthValidator, } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AllService } from 'src/app/Utils/services/all.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractControl } from '@angular/forms';
import { ThongTinHocPhiLePhiService } from 'src/app/utils/services/thong-tin-hoc-phi-le-phi.service';
export function removeSpaces(control: AbstractControl) {
  if (control && control.value && !control.value.replace(/\s/g, '').length) {
    control.setValue('');
  }
  return null;
}


@Component({
  selector: 'app-thong-tin-hoc-phi-le-phi',
  templateUrl: './thong-tin-hoc-phi-le-phi.component.html',
  styleUrls: ['./thong-tin-hoc-phi-le-phi.component.scss']
})
export class ThongTinHocPhiLePhiComponent implements OnInit {
  dataKhoanThu: any = [];
  dataBienLaiThu: any = [];
  dataTHKhoanThu: any = [];
  txtLop: any;
  txtHo_ten: any;
  Tong_da_nop: any;
  Tong_phai_nop: any;
  recorData: any
  arrayOne(n: number): any[] {
    return Array(n);
  }
  public com: common
  Token: any
  dataHeader: any = []
  dataTable: any = []
  Nam_hoc_arr: any = []
  dataHe: any = []
  dataKhoa: any = []
  dataKhoaHoc: any = []
  dataChuyenNganh: any = []
  dataLop: any = []
  dataChart: any = []
  listID_lop: string
  chart: any
  isDisplay: any = true
  dataKhoaHoc2: any = []
  dataChuyenNganh2: any = []
  dataLop2: any = []
  closeResult: string;
  filter = new FormGroup({
    Hoc_ky: new FormControl(""),
    Nam_hoc: new FormControl((new Date().getFullYear() - 1) + '-' + new Date().getFullYear()),
    ID_he: new FormControl(null),
    ID_khoa: new FormControl(""),
    ID_lop: new FormControl(""),
    ID_chuyen_nganh: new FormControl(""),
    Khoa_hoc: new FormControl(""),
    Lan_hoc: new FormControl(""),
    Ma_sv: new FormControl(""),
    Ho_ten: new FormControl(""),
  });
  constructor(
    private modalService: NgbModal,
    private ThongTinHocPhiLePhiService: ThongTinHocPhiLePhiService,
    private AllService: AllService,
    public router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
  ) { }
  ngOnInit(): void {
    let element, name, arr
    element = document.getElementById('menu1')
    arr = element.className.split(' ')
    name = 'menu-open'
    if (arr.indexOf(name) == -1) {
      element.className += ' ' + name
    }
    this.com = new common(this.router)
    this.com.CheckLogin();
    var a = this.com.getUserinfo()
    this.Token = a.Token

    this.getList()
  }
  getList() {
    this.spinner.show()
    let IDhe;
    this.AllService.getHe(this.Token).subscribe((z) => {
      this.dataHe = z
      IDhe = z[0].ID_he
      this.filter.patchValue({ ID_he: z[0].ID_he });
      this.AllService.getKhoa(this.Token).subscribe((z) => {
        this.dataKhoa = z
        this.AllService.getKhoaHoc(this.Token).subscribe((z) => {
          this.dataKhoaHoc = z.Data
          this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == IDhe);
          this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);

          this.AllService.getLop(this.Token).subscribe((z) => {
            this.dataChuyenNganh = z
            this.dataChuyenNganh2 = this.dataChuyenNganh
            this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_he == IDhe);
            this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
            this.dataLop = z
            this.dataLop2 = this.dataLop.filter(i => i.ID_he == IDhe);
          });
          this.spinner.hide()
        });
      });
    });
  }
  changeHe() {
    this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
    this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
    this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
    this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
    this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
  }
  changeKhoa() {
    if (this.filter.value.ID_khoa != "") {
      this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
    } else {
      this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
    }
  }
  changeKhoaHoc() {
    if (this.filter.value.Khoa_hoc != "") {
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
    } else {
      this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
    }

  }
  changeChuyenNganh() {
    if (this.filter.value.ID_chuyen_nganh != "") {
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      if (this.filter.value.Khoa_hoc != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      }
      this.dataLop2 = this.dataLop2.filter(i => i.ID_chuyen_nganh == this.filter.value.ID_chuyen_nganh);
    } else {
      this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
      if (this.filter.value.ID_khoa != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.ID_khoa == this.filter.value.ID_khoa);
      }
      if (this.filter.value.Khoa_hoc != "") {
        this.dataLop2 = this.dataLop2.filter(i => i.Khoa_hoc == parseInt(this.filter.value.Khoa_hoc));
      }
    }
  }

  getDataSinhVien() {
    this.spinner.show();
    if (this.filter.value.ID_lop == "") {
      this.dataLop2.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
    } else {
      this.listID_lop = this.filter.value.ID_lop
    }
    this.dataTable = []
    let req = {
      "Ho_ten": this.filter.value.Ho_ten,
      "dsID_Lop": this.listID_lop,
      'Ma_sv': this.filter.value.Ma_sv,
      'SBD': ''
    }
    this.ThongTinHocPhiLePhiService.getListSV(req, this.Token).subscribe((z) => {
      this.dataTable = z.DataSinhVien
      this.spinner.hide();

    });
  }
  submit() {
    this.listID_lop = ""
    this.getDataSinhVien()
  }

  xoa_dau(str) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ|ị/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // huyền, sắc, hỏi, ngã, nặng 
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // mũ â (ê), mũ ă, mũ ơ (ư)
    return str;
  }

  open(content, sizm, Loai, Data) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: sizm }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    this.txtLop = Data.Lop
    this.txtHo_ten = Data.Ho_ten
    this.recorData = Data
    this.ThongTinHocPhiLePhiService.getListTaiChinhSV(Data, this.Token).subscribe((z) => {
      this.dataKhoanThu = z.DataDanhSachKhoanThu
      this.dataBienLaiThu = z.DataBienLaiThu
      this.dataTHKhoanThu = z.KhoanThuTongHop.khoanthu
      this.Tong_da_nop = z.KhoanThuTongHop.Tong_tien_da_nop
      this.Tong_phai_nop = z.KhoanThuTongHop.Tong_tien_phai_nop
      this.spinner.hide();
    });
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}